var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderSummary2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235.00000000000003,
    height: 449.99999999999994,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    rx: 25,
    id: "svg_1",
    height: 450,
    width: 235,
    y: 0,
    x: 0,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2",
    height: 1,
    width: 1,
    y: 263,
    x: 906,
    stroke: "#000",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_9",
    y2: 244,
    x2: -8,
    y1: 146,
    x1: 178,
    stroke: "null",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_13",
    height: 0,
    width: 1,
    y: 154,
    x: 146,
    strokeWidth: 0,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    d: "m140,286l-5,-17",
    opacity: "NaN",
    stroke: "null",
    fill: "#71982d"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 0 0)",
    fontWeight: "bold",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    id: "svg_20",
    y: 54.99986,
    x: 65.93745,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Order Summary"), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_33",
    y: 417.49869,
    x: 120.5573,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Chat with Us &gt;"), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_45",
    y: 417.66687,
    x: 62.84109,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Need help?"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    rx: 10,
    id: "svg_75",
    height: 167.33349,
    width: 170.66683,
    y: 86.33361,
    x: 33.49992,
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_42",
    y: 104.33324,
    x: 45,
    strokeWidth: 0,
    fill: "#71982d"
  }, "30 Yard Roll Off Dumpster"), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_43",
    y: 118.99992,
    x: 45,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Pending"), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_76",
    y: 226.33336,
    x: 45,
    strokeWidth: 0,
    fill: "#71982d"
  }, "$200 + $45 delivery"), /*#__PURE__*/React.createElement("image", {
    stroke: "null",
    xlinkHref: "data:image/png;base64,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",
    id: "svg_78",
    height: 72,
    width: 150,
    y: 131.49999,
    x: 42.5
  }), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_79",
    y: 242.33338,
    x: 45,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Delivery on June 3 @ 3:00pm"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    rx: 10,
    id: "svg_80",
    height: 110.66677,
    width: 170.66683,
    y: 278.33379,
    x: 33,
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_81",
    y: 303.00009,
    x: 42.33333,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Vendor"), /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_82",
    y: 337.00013,
    x: 42,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Drop Off"), /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_83",
    y: 368.33349,
    x: 42.33333,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Payment"), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_84",
    y: 303,
    x: 99.66672,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Eco Waste Company"), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_85",
    y: 337.00013,
    x: 99.66672,
    strokeWidth: 0,
    fill: "#71982d"
  }, "101 Main Street"), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    id: "svg_86",
    y: 368.33349,
    x: 100,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Visa xxxx-5555"), /*#__PURE__*/React.createElement("path", {
    d: "M16.2426 6.34317L14.8284 4.92896L7.75739 12L14.8285 19.0711L16.2427 17.6569L10.5858 12L16.2426 6.34317Z",
    fill: "#71982d",
    transform: "translate(15,15)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSummary2);
export default __webpack_public_path__ + "static/media/order-summary-2.fa9217728ae4220ec2baa3c774349202.svg";
export { ForwardRef as ReactComponent };